import * as React from 'react'
import { Navigate } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import Loading from 'modules/layout/components/Page/Loading'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'
import { usePolicies } from 'modules/payroll_bundle/store/collections/policies'

const RedirectResultsPage = () => {
  const policies = usePolicies()
  const { navigation } = useNavigation()
  const {
    policyId,
    currentPeriod,
    setCurrentPolicy,
    policyPeriodCollection,
    loadingPolicyPeriodCollection,
  } = usePolicyPeriods()
  const periodId = currentPeriod?.id
  const { loading } = useAsyncData(
    // Though the collections are bootstrapped, these calls are necessary
    // or the policy periods aren't loaded in time.
    () => Promise.all([policies.fetch(), policyPeriodCollection.fetch()]),
    []
  )

  const isLoading = loading || loadingPolicyPeriodCollection

  const [didCheckPolicyId, setDidCheckPolicyId] = React.useState(false)

  // If we don't have a current period, set it before navigating.
  useUnsafeEffect(() => {
    if (!isLoading && !didCheckPolicyId) {
      if (policies.length) {
        setCurrentPolicy(policies.at(0)?.id)
      }
      setDidCheckPolicyId(true)
    }
  }, [isLoading, policies, setCurrentPolicy, didCheckPolicyId])

  if (isLoading || !didCheckPolicyId) {
    return <Loading />
  }

  const buildPath = () => {
    if (policyId && periodId) {
      return navigation.payrollBundle.policy.period.cycles.results.fullPath({ policyId, periodId })
    }

    return navigation.payrollBundle.fullPath()
  }

  return <Navigate to={buildPath()}></Navigate>
}

export default RedirectResultsPage
